import React from 'react';
import { Box } from '@mui/material';
import { extractYoutubeId } from '../utils/string.js';

const YoutubePlayer = ({
  videoId,
  videoUrl,
  start = 0,
  ...props
}) => {
  const _videoId = videoId || extractYoutubeId(videoUrl || '');
  return /*#__PURE__*/React.createElement(Box, props, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      aspectRatio: '16/9'
    }
  }, /*#__PURE__*/React.createElement("iframe", {
    style: {
      width: '100%',
      height: '100%'
    },
    src: `https://www.youtube.com/embed/${_videoId}?start=${start}`,
    title: "YouTube video player",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  })));
};

export { YoutubePlayer };
